import Router from 'vue-router'

function loadView(view) {
  return () => import(/* webpackChunkName: "[request]" */ `@/components/views/${view}.vue`)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/file-upload/'
    },
    {
      path: '/file-upload/',
      name: 'base',
      component: loadView('FileUploadView')
    },
    {
      path: '/file-upload/:uploadTypeSlug?/',
      name: 'uploadType',
      props: true,
      component: loadView('FileUploadView')
    }
  ]
})
